import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchInitiativeLinkRequest = {
	id: number;
	initiativeId: number;
	title: string;
	url: string;
};

export const patchInitiativeLink = createPatchEndpoint<PatchInitiativeLinkRequest>(
	({ id, initiativeId }) => `/api/v3/initiatives/${initiativeId}/links/${id}`
);
